import styled, {
  IFalconTheme,
  ResponsiveTypography,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';

export const NoBookingsText: StyledComponent<
  typeof ResponsiveTypography,
  IFalconTheme,
  {}
> = styled(ResponsiveTypography)`
  margin-bottom: ${Scale.m};
  ${({ theme }) => `color: ${theme.color.grey50};`};
`;
